import { combineReducers } from "redux"
import userReducer from "./userReducer"
import { spaceUsedReducer } from "./getUsedDataReducer"
import { appReducer } from "./appReducer"
import organizationReducer from "./OrganizationReducer"
import eventanillaReducer from "./eventanilla"
import { globalNotificationReducer } from "./globalNotificationReducer"
import clientsReducer from "./clients"
import adminAccessUserReducer from "./adminAccessUserReducer"

// definition and restructure
const rootReducer = combineReducers({
  app: appReducer,
  organization: organizationReducer,
  user: userReducer,
  spaceUsedReducer,
  eventanilla: eventanillaReducer,
  globalNotification: globalNotificationReducer,
  clients: clientsReducer,
  adminAccessUser: adminAccessUserReducer,
})

export default rootReducer
